import script from "./WantToReadBooksBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./WantToReadBooksBlock.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__